<template>
  <div class="modal__body">
    <div class="progress card">
      <div class="info">
        <img class="card__icon" :src="emailPointImage" alt="filter" />
        <div class="count">
          <h4>Total enviados:</h4>
          <p>{{ totalSentEmails?.value }}/ {{ data?.total }}</p>
        </div>
      </div>
      <div class="bar">
        <a-progress
          stroke-linecap="butt"
          :percent="displayPercent"
          :showInfo="false"
          size="500"
          strokeColor="#FFD666"
          height="100"
        />
      </div>
    </div>
    <h3>Interacción con destinatarios</h3>
    <section class="interaction">
      <div class="card card--stat">
        <h4>Tasa de apertura</h4>
        <p>{{ formatPercentage(data?.percentage_open) }}%</p>
        <span>{{ data?.total_opens }} abiertos</span>
      </div>
      <div class="card card--stat">
        <h4>Tasa de clics</h4>
        <p>{{ formatPercentage(data?.percentage_click) }}%</p>
        <span>{{ data?.total_clicks }} recibieron clics</span>
      </div>
      <div class="card card--stat">
        <h4>Tasa de clicthrough</h4>
        <p>{{ formatPercentage(data?.percentage_click_through_rate) }}%</p>
        <span>{{ data?.total_click_through_rate }} clics en enlaces</span>
      </div>
    </section>
    <h3>Entrega</h3>
    <section class="interaction">
      <div class="card card--stat">
        <a-tooltip>
          <template #title>Tasa total de emails entregados</template>
          <h4>Tasa de entregados</h4>
          <InfoCircleOutlined />
        </a-tooltip>
        <!-- <p>{{ receivedEmails?.percentage }}%</p>
        <span>{{ receivedEmails?.value }} entregados</span> -->
        <p>{{ formatPercentage(totalSentEmails?.percentage) }}%</p>
        <span>{{ totalSentEmails?.value }} entregados</span>
      </div>
      <div class="card card--stat">
        <a-tooltip>
          <template #title>Tasa total de emails entregados</template>
          <h4>Tasa de rebote</h4>
          <InfoCircleOutlined />
        </a-tooltip>
        <p>{{ formatPercentage(failedEmails?.percentage) }}%</p>
        <span>{{ failedEmails?.value }} no entregados</span>
      </div>
      <div class="card card--stat">
        <a-tooltip>
          <template #title>Tasa total de emails entregados</template>
          <h4>Tasa de cancelación de suscripción</h4>
          <InfoCircleOutlined />
        </a-tooltip>
        <p>{{ formatPercentage(data?.percentage_cancel_subscription) }}%</p>
        <span>{{ data?.total_cancel_subscription }} cancelaron suscripción</span>
      </div>
      <!-- <div class="card card--stat">
        <a-tooltip>
          <template #title>Tasa total de emails entregados</template>
          <h4>Frecuencia informes de spam</h4>
          <InfoCircleOutlined />
        </a-tooltip>
        <p>{{ data?.porcentage_total_spam || 0 }}%</p>
        <span>{{ data?.total_spam || 0 }} marcados como spam</span>
      </div> -->
    </section>
  </div>
</template>
<script setup lang="ts">
import { computed } from "vue";
import { InfoCircleOutlined } from "@ant-design/icons-vue";
import { EmailDashboard } from "@/@types/emails";

import emailPointImage from "@/app/strategies/assets/email-pointer.svg?url";

const props = defineProps<{ data: EmailDashboard }>();

const totalSentEmails = computed(() => props.data?.states.find((item) => item.name === "Enviados"));

const receivedEmails = computed(
  () => props.data?.states.find((item) => item.name === "Recibidos") || 0
);

const failedEmails = computed(
  () => props.data?.states.find((item) => item.name === "Fallidos") || 0
);

const displayPercent = computed(() => {
  const totalSent = totalSentEmails.value?.value || 0;
  const total = props.data?.total || 1;
  return (totalSent / total) * 100;
});

const formatPercentage = (percentage?: number | null | undefined): string => {
  if (percentage == null || percentage == undefined) return "-";
  const rounded = Math.round(percentage * 100) / 100; 
  return Number.isInteger(rounded) ? `${rounded}` : rounded.toFixed(2);
};
  

</script>
<style lang="sass" scoped>
h3
  margin: 10px 0 10px
.card
  border: $border-normal
  border-radius: 2p5
  padding: 12px 8px

  &--stat
    display: flex
    flex-direction: column
    align-items: center
    width: 100%
    p
      font-size: 30px
      margin: 0
      font-weight: 500
.interaction
  display: flex
  gap: 10px
.graphic
  height: 80px
.progress
  display: flex
  padding: 10px
  align-items: center
  .info
    width: 35%
    display: flex
    gap: 10px
    justify-content: center
    .count
      h4
        margin: 0
      p
        font-size: 30px
        font-weight: 600
        margin: 0
  .bar
    width: 65%
</style>
<style>
.card--stat span {
  display: flex;
  gap: 5px;
}
.card--stat span h4 {
  margin: 0;
}
.modal__body .ant-progress-inner {
  height: 40px;
  border-radius: 0;
}
.modal__body .ant-progress-inner .ant-progress-bg {
  height: 40px !important;
}
</style>
